import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { AgendaTemplateFragmentDoc } from '../../fragments/generated/AgendaTemplate';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AgendaTemplatesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.AgendaItemTemplatesFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type AgendaTemplatesQuery = { agendaItemTemplates: { success: boolean, edges?: Array<{ node: { createdById: string, createdAt: string, updatedAt: string, id: string, versionNumber?: number | null, name: string, agendaItemIds: Array<string>, status: Types.AgendaItemTemplateStatusEnum, meetingsCount: number } }> | null } };


export const AgendaTemplatesDocument = /*#__PURE__*/ gql`
    query agendaTemplates($filters: AgendaItemTemplatesFilters, $first: Float, $after: String, $sort: [SortType!]) {
  agendaItemTemplates(
    filters: $filters
    first: $first
    after: $after
    sort: $sort
  ) {
    edges {
      node {
        ...AgendaTemplate
      }
    }
    success
  }
}
    ${AgendaTemplateFragmentDoc}`;

export function useAgendaTemplatesQuery(options?: Omit<Urql.UseQueryArgs<AgendaTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<AgendaTemplatesQuery, AgendaTemplatesQueryVariables>({ query: AgendaTemplatesDocument, ...options });
};